"use client";
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { GrSpotify } from "react-icons/gr";
import { FaAudible, FaTwitch } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import {
  SiAudiomack,
  SiAmazonmusic,
  SiAudacity,
  SiApplemusic,
  SiYoutubemusic,
  SiAudioboom,
} from "react-icons/si";

const iconList = [
  { component: GrSpotify, key: "spotify" },
  { component: SiApplemusic, key: "applemusic" },
  { component: FaAudible, key: "audible" },
  { component: SiAudacity, key: "audacity" },
  { component: SiAudiomack, key: "audiomack" },
  { component: SiYoutubemusic, key: "youtubemusic" },
  { component: SiAmazonmusic, key: "amazonmusic" },
  { component: FaTwitch, key: "twitch" },
  { component: SiAudioboom, key: "audioboom" },
  { component: FaXTwitter, key: "xtwitter" },
];

const containerVariants = {
  hidden: { opacity: 1 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0 },
};

const Partners: React.FC = () => {
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1024);
    };

    handleResize(); // Check screen size on mount
    window.addEventListener("resize", handleResize); // Add event listener for window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up the event listener on unmount
    };
  }, []);

  const iconsToShow = isLargeScreen ? iconList : iconList.slice(0, 4);

  return (
    <motion.div
      className="border-2 border-slate-100 rounded-full px-8 py-4 flexer !justify-around w-full mt-6 hover:border-orange-500 mx-4 lg:mx-0 bg-slate-100/80"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      {iconsToShow.map(({ component: IconComponent, key }) => (
        <motion.div
          key={key}
          variants={itemVariants}
          whileHover={{ scale: 1.2 }}
          whileTap={{ scale: 0.9 }}
        >
          <IconComponent className="text-slate-600 text-4xl" />
        </motion.div>
      ))}
    </motion.div>
  );
};

export default Partners;
